import http from "../../utils/http";

export const getAdContents = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/ad/content/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const addAdContents = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/ad/content`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const editAdContents = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/ad/content/${idx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteAdContents = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/ad/content`, { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const activeChange = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/ad/content/active/change`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAdHistories = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/ad/histories`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * @returns active 중인 content list
 * 시작일, 종료일, 활성 여부의 검색 조건을 받음
 */
export const getActiveAdContent = () => {
  return new Promise((resolve, reject) => {
    http
      .get(`/ad/content/active/list`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * @returns 클릭시 해당 컨텐츠의 view 정보가 기록됨
 * @params
 * { adContentIdx: 광고 콘텐츠 idx }
 */
export const adView = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/ad/view`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};